import React, { useEffect, useState } from 'react';
import { Search, CheckCircle } from 'lucide-react';
import { updateOnboardStatus } from '../../../services/coachAPI';


const Step4BackgroundCheck = ({ onNext, onBack, coachData }) => {
  

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b">
        <div className="p-2 bg-purple-100 rounded-lg">
          <Search className="h-6 w-6 text-purple-600" />
        </div>

        <div>
          <h2 className="text-xl font-bold text-gray-900">
            Step 4: Background Check Authorization
          </h2>
          <p className="text-sm text-gray-500">
            Authorize YAU to conduct a background investigation
          </p>
        </div>
      </div>

      <h1>Comming</h1>
    </div>
  );
};

export default Step4BackgroundCheck;